(function () {
    var searchFacets = {
        url: location.href,
        $searchFilters: $('.search__filters'),
        $appliedUrl: null,
        $standardLinkUrl: null,

        init: function () {
            var standardFacetUrl;
            var url;
            if (searchFacets.$searchFilters.find("a[title|='Reference/Standard']").length) {
                searchFacets.$standardLinkUrl = searchFacets.$searchFilters.find("a[title|='Reference/Standard']");

                standardFacetUrl = searchFacets.$standardLinkUrl.attr('href');
                url = searchFacets.removeParamFromUrl(standardFacetUrl, 'PubType');
                searchFacets.$appliedUrl = searchFacets.addParamToUrl(url, 'PubType', 'reagentsBookSeries');
                searchFacets.setUrl.setStandardUrl();
            }
        },

        addParamToUrl: function (url, param, value) {
            var separator;
            if (typeof url !== 'undefined' && typeof param !== 'undefined' && typeof value !== 'undefined') {
                separator = url.indexOf('?') === -1 ? '?' : '&';
                return url + separator + param + '=' + value;
            }
            return url;
        },

        removeParamFromUrl: function (url, param) {
            //split into main url and queryString
            var urlParts = url.split('?');
            var prefix;
            var params;
            var i;

            if (urlParts.length > 1) {
                //only if there is queryString
                //prefix of parameter..for eg. 'startPage='
                prefix = encodeURIComponent(param) + '=';
                //array containing all the parameters
                params = urlParts[1].split(/[&;]/g);
                for (i = params.length; i-- > 0; ) {
                    if (params[i].lastIndexOf(prefix, 0) !== -1) {
                        //remove the matched param
                        params.splice(i, 1);
                    }
                }
                if (params.length > 0) {
                    return urlParts[0] + '?' + params.join('&');
                } else {
                    return urlParts[0];
                }
            } else {
                return url;
            }
        },

        setUrl: {
            // set url to clear all filters
            setStandardUrl: function () {
                searchFacets.$standardLinkUrl.attr('href', searchFacets.$appliedUrl);
            },
        },
    };

    UX.searchFacets = searchFacets; // add to global namespace
})();
